import { render } from "./ArchivedProjectsListView.vue?vue&type=template&id=4f4835d7"
import script from "./ArchivedProjectsListView.vue?vue&type=script&lang=js"
export * from "./ArchivedProjectsListView.vue?vue&type=script&lang=js"

import "./ArchivedProjectsListView.vue?vue&type=style&index=0&id=4f4835d7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__